/* global modForm Set */
import { trackFormSubmissionFlow } from '../../../helpers';
/**
 * Get form data as an object
 * @returns {Object} - form data as an object
 */
export function getFormData() {
	trackFormSubmissionFlow({ inGetFormData: true });
	const formDataRaw = new FormData(modForm.opts.form);
	const formData = {};

	for (const name of new Set(formDataRaw.keys())) {
		const values = formDataRaw.getAll(name);
		formData[name] = values.length > 1 ? values : values[0];
	}

	const croData = {};
	const $croInputs = modForm.opts.form.querySelectorAll('input[data-cro]');
	const croNames = [...new Set(Array.from($croInputs).map(input => input.name).filter(Boolean))];

	croNames.forEach(name => {
		const values = formDataRaw.getAll(name);
		const nonEmpty = values.filter(value => (value || '').trim() !== '');

		if (nonEmpty.length > 0) {
			croData[name] = nonEmpty.join(', ');
		}
	});

	// Strip skipped questions data from cro tag and from form data
	const skippedQuestions = modForm.opts.form.querySelectorAll('.skipped');
	if (skippedQuestions.length > 0) {
		skippedQuestions.forEach(question => {
			const name = question.getAttribute('data-step-name');
			if (name && name !== 'UtilityProvider') {
				delete croData[name];
				delete formData[name];
			}
		});
	}

	if (Object.keys(croData).length !== 0) {
		formData.CROTag = JSON.stringify(croData);
	}

	// Process homeowner checkbox
	if (!formData.homeowner || formData.homeowner === '' || formData.homeowner === 'on') {
		const $homeownerCheckbox = modForm.opts.form.querySelector('input[type="checkbox"][name="homeowner"]');

		if ($homeownerCheckbox && $homeownerCheckbox.length) {
			formData.homeowner = $homeownerCheckbox.checked ? 'yes' : 'no';
		}
	}

	return formData;
}
